import img7 from "../../Images/11221.jpeg";
import img8 from "../../Images/11222.jpeg";
import img9 from "../../Images/11223.jpeg";
import img10 from "../../Images/11224.jpeg";
import img11 from "../../Images/11.jpg";
import img12 from "../../Images/12.jpg";
import img13 from "../../Images/13.jpeg";
import img16 from "../../Images/16.jpg";

const Adata = [
  {
    image: img7,
    alts: "HTML",
    title: "HTML Workshop for 8 Weeks Cert.",
  },
  {
    image: img8,
    alts: "CSS",
    title: "Completed the CSS for 1 Week.",
  },
  {
    image: img9,
    alts: "Javascript",
    title: "Introduction to JavaScript.",
  },
  {
    image: img10,
    alts: "Responsive",
    title: "Built Responsive Website.",
  },
  {
    image: img13,
    alts: "Frontend",
    title: "Frontend Fundamentals",
  },
  {
    image: img16,
    alts: "React js",
    title: "React JS Beginner Level",
  },

  {
    image: img11,
    alts: "Tailwind",
    title: "Tailwind CSS",
  },
  {
    image: img12,
    alts: "GitHub",
    title: "GitHub",
  },
];
export default Adata;
